export const org_status = {
	1: 'ปกติ',
	2: 'ปิดการใช้งาน',
	3: 'หมดอายุการมอบอำนาจ',
	4: 'รอเปิดใช้งาน'
}
